import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Body1 } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";
import { PROJECT_TEMPLATE_FILE } from "~/pages/ProjectTemplates/utils.js";
import { isGoogleDriveFile, isDropboxFile } from "~/utils/files";
import { AttachmentListItem } from "./AttachmentListItem.jsx";
import { PrepareDownload } from "../component.prepare_download.jsx";
import { fileType } from "../FilePreview/types.jsx";

export const AttachmentList = ({ items, downloadAllUrl, onItemClick, hideTitle, className }) => {
  const { t } = useTranslation();
  const canSeeDownloadAllLink = useMemo(() => {
    if (!downloadAllUrl) {
      return false;
    }

    const filteredItems = items.filter((item) => {
      const type = item.class === PROJECT_TEMPLATE_FILE ? item.type : item.class;
      return !isGoogleDriveFile(type) && !isDropboxFile(type);
    });

    return filteredItems.length > 1;
  }, [downloadAllUrl, items]);

  return (
    <div className={classNames("attachments", className)}>
      {!hideTitle ? (
        <Body1
          weight="bold"
          className="tw-mb-3"
        >
          {t("Attachments")}
        </Body1>
      ) : null}
      <ul className={classNames("attachments_list", { "tw-mt-6": hideTitle })}>
        {items.map((item) => (
          <AttachmentListItem
            item={item}
            key={item.id}
            onClick={onItemClick}
          />
        ))}
      </ul>
      {canSeeDownloadAllLink ? (
        <PrepareDownload
          url={downloadAllUrl}
          className="tw-my-4"
        />
      ) : null}
    </div>
  );
};

AttachmentList.propTypes = {
  items: PropTypes.arrayOf(fileType),
  downloadAllUrl: PropTypes.string,
  onItemClick: PropTypes.func,
  hideTitle: PropTypes.bool,
  className: PropTypes.string,
};

AttachmentList.defaultProps = {
  items: [],
  hideTitle: false,
};
